import { useState, useEffect } from 'react';

export function usePremiumStatus() {
  const [premiumStatus, setPremiumStatus] = useState({
    has_paid: false,
    is_premium: false,
    total_plans_created: 0,
    total_exercises_created: 0,
    plans_remaining: 4,
    exercises_remaining: 4,
    loading: true
  });

  useEffect(() => {
    loadPremiumStatus();
  }, []);

  const loadPremiumStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        // Guest users: always free tier
        setPremiumStatus({
          has_paid: false,
          is_premium: false,
          total_plans_created: 0,
          total_exercises_created: 0,
          plans_remaining: 4,
          exercises_remaining: 4,
          loading: false
        });
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/user/premium-status`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (response.ok) {
        const data = await response.json();
        setPremiumStatus({ ...data, loading: false });
      } else {
        setPremiumStatus(prev => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error('Error loading premium status:', error);
      setPremiumStatus(prev => ({ ...prev, loading: false }));
    }
  };

  const refresh = () => {
    loadPremiumStatus();
  };

  return { ...premiumStatus, refresh };
}
